export default "__VITE_ASSET__f2516579__"